<template>
  <div class="select-wrapper" @click="cityClick">
    <cube-select
      v-model="formItem.value"
      :title="formItem.title"
      :options="cityList"
      :placeholder="formItem.placeholder || formItem.title"
      :disabled="relyKeyItem && !cityList.length"
      :confirmTxt="$t('确认')"
      :cancelTxt="$t('取消')"
      @change="changeSelect"
    >
    </cube-select>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import { post } from "../../tools/request";
import { emitFormUpdate } from "../../tools/utils";
import {
  ends,
  LOGIN_CONFIG,
  SUPPORT_COUNTRY as sc,
} from "../../tools/constant";

// 手机号基本格式
const REG_PHONE_NUM = /^\d+$/;

export default {
  props: ["formItem", "idx", "relyKeyItem"],
  data() {
    return {
      phoneNum: "",
      phoneNumValidate: false,
      cityList: []
    };
  },
  mounted() {
    console.log(this.relyKeyItem)
  },
  computed: {
    ...mapState(["_ticket", "_login_btn_text", "_phone_focus_global"]),
    isWA() {
      return true;
    },
    params() {
      return new URLSearchParams(location.search);
    },
    location_country() {
      return this.params.get("location_country");
    },
    // otherKeyOption() {
    //   if (!this.relyKeyItem) return null
    //   let otherKeyValue = (this.relyKeyItem || []).value
    //   if (otherKeyValue && otherKeyValue != 0) {
    //     return this.formItem.option_list[otherKeyValue]
    //   } else {
    //     return []
    //   }
    // }
  },
  watch: {
    relyKeyItem: {
      handler(newV) {
        if (newV && newV.value && newV.value != '0') {
          this.getCityListByProduct(newV.value)
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapMutations(["setState"]),
    cityClick() {
      Omega.trackEvent("ibt_gd_whatsapp_select_box_ck", "", {
        type: this.formItem.key
      });
    },
    changeSelect(value, index, text) {
      this.setState({
        _area: {
          text: text,
          value: value
        }
      });
      this.formItem.value = value
      emitFormUpdate(this, this.idx);
    },
    getCityListByProduct(productVal) {
      if (!productVal) return
      let up = new URLSearchParams(location.search)
      up.set('product', productVal)
      post(process.env.GET_OPEN_CITYLIST_BY_PRODUCT, up)
      .then(data => {
        this.setState({ _open_type: data.open_type });
        this.cityList = data.list
      })
      .catch(err => {
        console.log(err)
      });
    }
  },
  components: {},
};
</script>
<style lang="scss" scoped>
@import "../../css/mixin.scss";
.select-wrapper {
  // padding: 0.24rem;
  margin: 0 0.4rem 0.24rem 0.4rem;
  .cube-select {
    height: .96rem;
    padding: 0.24rem .56rem .24rem .24rem;
    border-radius: 0.08rem;
    border: 0.02rem solid #dddddd;
    font-size: .32rem;
    font-weight: 700;
    &::after,
    .cube-select-icon {
      display: none;
    }
    ::v-deep .cube-select-placeholder,
    ::v-deep .cube-select-text {
      font-size: .32rem;
      font-weight: 700;
    }
    ::v-deep .cube-select-icon {
      width: .32rem;
      height: .32rem;
      right: .24rem;
      border: none;
      background-size: 0.32rem;
      background-image: url("../../images/icon_arrow_down.png");
    }
  }
  // &.phone-wrapper-wa {
  //   align-items: center;
  //   padding: 0.24rem;
  //   margin: 0 0.4rem 0.24rem 0.4rem;
  //   border: 0.02rem solid #dddddd;
  //   .code,
  //   .input {
  //     font-weight: 700;
  //   }
  // }
  // .input {
  //   flex: 1;
  //   padding-left: 0.34rem;
  //   input {
  //     font-size: 0.4rem;
  //     display: block;
  //     width: 100%;
  //     height: 100%;
  //     background: transparent;
  //   }
  // }
}
</style>


